// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__vAEXT"};